function matchExtension(find: string, files: string | readonly string[]): boolean {
    const normalizedFiles = Array.isArray(files) ? files : [files];
    const normalizedFind = find.startsWith('.') ? find.slice(1).toLowerCase() : find.toLowerCase();

    for (const item of normalizedFiles) {
        const lowerItem = item.toLowerCase();

        if (lowerItem.endsWith('.' + normalizedFind)) {
            return true;
        }
    }

    return false;
}

// ----------------------------------------------------------------------------

export default matchExtension;
